// Libraries
var React = require('react');
var $ = require('jquery');
var cloneDeep = require('lodash/cloneDeep');

// Styles
require('./FixturesList.scss');

// Components
var FixtureGroup = require('./FixtureGroup');
var FixturesFilter = require('./FixturesFilter');

// Assets
var spinner = require('images/Rolling.svg');

class FixturesListModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedSeasonId: this.props.data.fixtureFilters.seasons.find(season => season.selected).key,
			showPrevious: this.props.data.hasPrevious,
			showNext: this.props.data.hasNext,
			showError: false,
			filtered: this.props.data.isFiltered || false,
			isLoading: false,
			fixtureFilters: this.props.data.fixtureFilters,
			inUseFixtures: this.props.data.months,
			filteredFixtures: this.props.data.months,
		};
	}

	updateQueryString = () => {
		const teamQuery = this.teams.value ? `&q=${this.teams.value}` : '';

		window.history.replaceState({}, '', `${window.location.pathname}?season=${this.seasons.value}&competition=${this.competitions.value}${teamQuery}`);
	};

	handleSeasonChange = (event) => {
		const elem = event.target;

		this.setState({ isLoading: true });

		$.ajax({
			method: "GET",
			url: elem.options[elem.selectedIndex].getAttribute('data-url')
		})
		.done(data => {
			this.setState({ 
				filtered: true, 
				selectedSeasonId: parseInt(elem.options[elem.selectedIndex].id, 10), 
				inUseFixtures: data, 
				filteredFixtures: data,
				showPrevious: data.some(x => x.isShown === false), 
				showNext: false,
				isLoading: false
			}, () => {
				this.resetFields(true);
				window.LazyLoad.concat();
				this.updateQueryString();
			});
		})
		.fail(data => {
			this.setState({ showError: true, filteredFixtures: [], isLoading: false });
		});
	}

	handleResetFilters = () => {
		this.resetFields();

		this.setState({
			filtered: false,
			filteredFixtures: this.props.data.months,
			inUseFixtures: this.props.data.months,
			showPrevious: this.props.data.months.some(x => x.isShown === false),
			showNext: false,
			showError: false
		}, () => {
			this.updateQueryString();
			window.LazyLoad.concat();
		});
	}

	filter = () => {
		let months = cloneDeep(this.state.inUseFixtures);
		const teamSearchTerm = this.teams.value;
		const competitionId = parseInt(this.competitions.options[this.competitions.selectedIndex].id, 10);

		const teamNameMatch = item => {
			return teamSearchTerm !== '' ? item.fixture !== null && (
				item.fixture.homeTeam.name.toLowerCase().startsWith(teamSearchTerm.toLowerCase()) ||
				item.fixture.awayTeam.name.toLowerCase().startsWith(teamSearchTerm.toLowerCase())
			) : true;
		};

		const competitionMatch = item => {
			return competitionId !== 0 ? item.fixture !== null && item.fixture.competition.id === competitionId : true;
		};

		months = months.map(month => {
			return Object.assign({}, month, {items: month.items
				.filter(teamNameMatch)
				.filter(competitionMatch)
			});
		});

		if (months.every(month => month.items.length === 0)) {
			this.setState({
				filtered: true,
				filteredFixtures: [],
				showPrevious: false,
				showNext: false,
				showError: true
			}, this.updateQueryString);
		} else if (months.filter(month => month.isShown).every(month => month.items.length === 0)) {
			this.setState({
				filtered: true,
				filteredFixtures: this.toggleIsShown(months),
				showError: false,
				showNext: false,
				showPrevious: false
			}, () => {
				this.updateQueryString();

				if (window.LazyLoad)
					window.LazyLoad.concat();
			});
		} else {
			this.setState({
				filtered: true,
				filteredFixtures: months,
				showPrevious: !this.state.inUseFixtures[0].isShown && !this.state.inUseFixtures.every(month => month.isShown),
				showNext: this.state.inUseFixtures[0].isShown && !this.state.inUseFixtures.every(month => month.isShown),
				showError: false,
			}, () => {
				this.updateQueryString();

				if (window.LazyLoad)
					window.LazyLoad.concat();
			});
		}
	};

	toggleIsShown = fixtures => fixtures
		.map(i => Object.assign({}, i, {isShown: !i.isShown}))

	handlePagingClick = () => {
		this.setState({
			showPrevious: !this.state.showPrevious,
			showNext: !this.state.showNext,
			filteredFixtures: this.toggleIsShown(this.state.filteredFixtures),
			inUseFixtures: this.toggleIsShown(this.state.inUseFixtures)
		}, window.LazyLoad.concat);
	}

	resetFields = searchOnly => {
		this.teams.value = '';
		this.competitions.selectedIndex = 0;
		if (!searchOnly) {
			this.seasons.selectedIndex = this.props.data.fixtureFilters.seasons
				.reduce((acc, val, index) => val.selected ? index : acc, 0);
		}
	}

	render() {
		return (
			<div className="FixturesList">
				<h2>{this.props.data.title}</h2>
				<FixturesFilter
					onSeasonChange={this.handleSeasonChange}
					onReset={this.handleResetFilters}
					onFilter={this.filter}
					data={this.state.fixtureFilters}
					selectedSeasonId={this.state.selectedSeasonId}
					filtered={this.state.filtered}
					competitionsRef={(competitions) => this.competitions = competitions}
					seasonsRef={(seasons) => this.seasons = seasons}
					teamsRef={(teams) => this.teams = teams}
				/>
				{!this.state.isLoading && 
					<div className="FixturesList__navigation">
						{this.state.showPrevious &&
							<button className="FixturesList__previous" onClick={this.handlePagingClick}>Previous months</button>
						}
						{this.state.showNext &&
							<button className="FixturesList__next" onClick={this.handlePagingClick}>Current months</button>
						}
					</div>
				}
				{this.state.showError &&
					<p>No results found</p>
				}
				{this.state.isLoading ? (
					<img src={spinner} className="spinner" alt="Loading..." />
				) : (this.state.filteredFixtures.filter(item => item.isShown).map((month, index) =>
					<FixtureGroup month={month} key={index} />
				))}
			</div>
		)
	}
}

module.exports = FixturesListModule;



// WEBPACK FOOTER //
// ./src/components/Fixtures/FixturesListModule.js